import React, { useContext } from 'react';
import { Col, Row } from 'antd';

import OptimizeRoiDisplay from '@totem/components/ticketing/details/optimize/optimizeRoiDisplay';
import OptimizeSavingsDisplay from '@totem/components/ticketing/details/optimize/optimizeSavingsDisplay';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import HeaderItem from '@totem/components/ui_components/headers/HeaderItem';
import Currency from '@totem/components/ui_components/widgets/currency/Currency';
import { isNotNull } from '@totem/utilities/common';

const NaOptimizePanel = () => {
  const { ticket } = useContext(TicketContext);

  const hasOptimize =
    isNotNull(ticket) &&
    isNotNull(ticket.ticket.extras) &&
    isNotNull(ticket.ticket.extras.optimize);

  return (
    <div>
      <Row>
        <Col span={6}>
          <HeaderItem title="Savings Potential">
            {hasOptimize &&
            isNotNull(ticket.ticket.extras.optimize.savingsPotential) ? (
              <OptimizeSavingsDisplay
                optimize={ticket.ticket.extras.optimize}
              />
            ) : (
              ''
            )}
          </HeaderItem>
          <HeaderItem title="Required Investment">
            {hasOptimize &&
            isNotNull(ticket.ticket.extras.optimize.requiredInvestment) ? (
              <span style={{ textAlign: 'left', display: 'block' }}>
                <Currency
                  amount={ticket.ticket.extras.optimize.requiredInvestment}
                />
              </span>
            ) : (
              ''
            )}
          </HeaderItem>
          <HeaderItem title="Return on Investment">
            {hasOptimize && (
              <OptimizeRoiDisplay optimize={ticket.ticket.extras.optimize} />
            )}
          </HeaderItem>
        </Col>
        <Col span={6}>
          <HeaderItem title="Category">
            {hasOptimize && isNotNull(ticket.ticket.extras.optimize.category)
              ? ticket.ticket.extras.optimize.category
              : ''}
          </HeaderItem>
          <HeaderItem title="Level of Effort">
            {hasOptimize &&
            isNotNull(ticket.ticket.extras.optimize.levelOfEffort)
              ? ticket.ticket.extras.optimize.levelOfEffort
              : ''}
          </HeaderItem>
          <HeaderItem title="Scope of Return">
            {hasOptimize &&
            isNotNull(ticket.ticket.extras.optimize.scopeOfReturn)
              ? ticket.ticket.extras.optimize.scopeOfReturn
              : ''}
          </HeaderItem>
        </Col>
        <Col span={10}>
          <HeaderItem title="Steps Required">
            {hasOptimize &&
            isNotNull(ticket.ticket.extras.optimize.stepsRequired)
              ? ticket.ticket.extras.optimize.stepsRequired
              : ''}
          </HeaderItem>
        </Col>
        <Col span={2}>
          <span />
        </Col>
      </Row>
    </div>
  );
};

export default NaOptimizePanel;
